import { render, staticRenderFns } from "./GalleryListComponent.vue?vue&type=template&id=51f2d44d&scoped=true"
import script from "./GalleryListComponent.vue?vue&type=script&lang=js"
export * from "./GalleryListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2d44d",
  null
  
)

export default component.exports